import clsx from 'clsx';
import { useMemo } from 'react';
import { embedVideoHandler } from '../Embed/handler/video';
import type { MdComponentIndexProps } from '../type';
import { transformCssUnit } from '../utils/transformCssUnit';
import styles from './Video.module.less';
import { flow } from '../../../../util/flow/';

type EmbedRes = JSX.Element | URL;

// CSS custom properties interface for TypeScript
interface CustomCSSProperties extends React.CSSProperties {
  '--app-markdown-video-ratio': string;
}

function raw(input: EmbedRes): JSX.Element {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;

  return <video src={input.href} controls />;
}

const el = <video src={''} controls />;

const videoHandler = flow(embedVideoHandler, raw);

export function MarkdownVideo(
  props: {
    src?: string;
    width?: string;
    height?: string;
    size?: string;
    ratio?: string;
  } & MdComponentIndexProps,
) {
  const { src = '', width = '', height = '', size = 'large', ratio } = props;
  
  const videoStyle = {
    width: transformCssUnit(width),
    height: transformCssUnit(height),
    '--app-markdown-video-ratio': height ? transformCssUnit(width) : ratio || '56.25%',
  } as CustomCSSProperties;
  
  return (
    <div
      className={clsx(styles.VideoContainer, {
        [styles['VideoContainer--small']]: size === 'small',
        [styles['VideoContainer--middle']]: size === 'middle',
        [styles['VideoContainer--large']]: size === 'large',
      })}
      style={videoStyle}
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      {useMemo(() => {
        try {
          const url = new URL(src.startsWith('//') ? 'https:' + src : src);

          if (url.protocol === 'tcplayer:') {
            // 腾讯云超级播放器
            // 还要注入 script ，link
            return null;
          }

          if (url.protocol === 'http:' || url.protocol === 'https:') {
            return videoHandler(url);
          }

          // 不支持其他协议

          return null;
        } catch (e) {
          return null;
        }
      }, [src]) ?? el}
    </div>
  );
}

MarkdownVideo.attributes = ['src', 'width', 'height', 'size', 'ratio'];
